import { HERO_VIDEO_SRC, INSTAGRAM_URL, TELEGRAM_URL } from '../config/media';

function ExternalLinkIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10.5 1.75H12.25V3.5M12.25 1.75L6.125 7.875M12.25 1.75V5.25M12.25 8.75V11.375C12.25 11.996 11.746 12.5 11.125 12.5H2.625C2.004 12.5 1.5 11.996 1.5 11.375V2.875C1.5 2.254 2.004 1.75 2.625 1.75H5.25"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SocialButton({ href, label, variant = 'dark' }) {
  const isLight = variant === 'light';

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex w-full items-center justify-center gap-2.5 rounded-full border bg-transparent px-5 py-2.5 font-sans text-[0.6875rem] uppercase tracking-[0.12em] no-underline transition-colors md:w-auto md:justify-start ${
        isLight
          ? 'border-white text-white hover:bg-white hover:text-black'
          : 'border-black text-black hover:bg-black hover:text-white'
      }`}
    >
      <ExternalLinkIcon />
      {label}
    </a>
  );
}

function VideoHero({
  videoSrc = HERO_VIDEO_SRC,
  instagramUrl = INSTAGRAM_URL,
  telegramUrl = TELEGRAM_URL,
}) {
  return (
    <section className="w-full bg-white">
      <div className="relative h-[65vh] w-full overflow-hidden bg-black md:h-[calc(100dvh-5.5rem)]">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
        >
          <source src={videoSrc} type="video/mp4" />
        </video>

        <div className="absolute bottom-10 left-10 z-10 hidden md:block">
          <div className="flex flex-row gap-3">
            <SocialButton href={instagramUrl} label="Instagram" variant="light" />
            <SocialButton href={telegramUrl} label="Telegram" variant="light" />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3 px-5 py-8 md:hidden">
        <SocialButton href={instagramUrl} label="Instagram" variant="dark" />
        <SocialButton href={telegramUrl} label="Telegram" variant="dark" />
      </div>
    </section>
  );
}

export default VideoHero;
